import useTestId from '@ori/testid-generator';
import type { DetailedHTMLProps, FormEvent, HTMLProps } from 'react';
import { forwardRef, useCallback, useContext } from 'react';

import { MyselfSection, OtherCustomersSection } from '../../../components';
import { stateContext } from '../../../contexts';
import { FormGrid } from '../../../styled';
import { ECustomerTypeSelection } from '../../../types';

export const CustomerSelectionForm = forwardRef<
  HTMLFormElement,
  DetailedHTMLProps<HTMLProps<HTMLFormElement>, HTMLFormElement>
>(({ onChange }, ref) => {
  const { getTestIdProps } = useTestId();
  const { selectedCustomerType, setCustomerType } = useContext(stateContext);
  const handleChange = useCallback(
    ({ currentTarget: { value } }: FormEvent<HTMLInputElement>) => {
      setCustomerType(value as ECustomerTypeSelection);
    },
    [setCustomerType],
  );

  return (
    <FormGrid
      ref={ref}
      {...getTestIdProps('customer-selection-form')}
      onChange={onChange}
    >
      <MyselfSection
        selected={selectedCustomerType === ECustomerTypeSelection.Myself}
        value={ECustomerTypeSelection.Myself}
        onChange={handleChange}
      />
      <OtherCustomersSection
        selected={selectedCustomerType === ECustomerTypeSelection.ExistingCustomer}
        value={ECustomerTypeSelection.ExistingCustomer}
        onChange={handleChange}
      />
    </FormGrid>
  );
});
